// Curated documentation metadata for each Postman collection item.
// Keyed by the exact "name" field used in public/collection.json.
const endpointMeta = {
  'Check client': {
    slug: 'check-client',
    category: 'Client Management',
    summary: 'Check whether a client already exists',
    description:
      'Looks up a client by their national ID number to determine whether they already exist in Definite Assurance records before creating a new client.',
  },
  'createClient': {
    slug: 'create-client',
    category: 'Client Management',
    summary: 'Create a new client record',
    description:
      'Registers a new client using their personal details. Returns the newly created client OID, which is required by downstream endpoints such as New Proposal.',
  },
  'products': {
    slug: 'products',
    category: 'Products & Pricing',
    summary: 'List available insurance products',
    description:
      'Returns the catalogue of insurance products and cover options available for quoting and proposal creation.',
  },
  'makes': {
    slug: 'makes',
    category: 'Products & Pricing',
    summary: 'List vehicle makes and models',
    description:
      'Returns the reference list of vehicle makes (and associated model codes) used when submitting a motor proposal.',
  },
  'calculatePremium': {
    slug: 'calculate-premium',
    category: 'Products & Pricing',
    summary: 'Calculate a premium quote',
    description:
      'Calculates the premium breakdown (basic premium, PHCF, training levy, stamp duty and gross premium) for a given product, cover option and vehicle profile.',
  },
  'intermediary checker': {
    slug: 'intermediary-checker',
    category: 'Intermediary Management',
    summary: 'Check whether an intermediary exists',
    description:
      'Verifies whether an intermediary (agent) is already registered using their identification number.',
  },
  'Intermediary Onboarding': {
    slug: 'intermediary-onboarding',
    category: 'Intermediary Management',
    summary: 'Register a new intermediary',
    description:
      'Onboards a new intermediary (agent) onto the platform. The intermediary is created in a pending state, awaiting approval.',
  },
  'Check Policy': {
    slug: 'check-policy',
    category: 'Policy & Proposals',
    summary: 'Check an existing policy by registration number',
    description:
      'Looks up an active policy using the vehicle registration number, returning its proposal number, OID and expiry date if one exists.',
  },
  'New Proposal': {
    slug: 'new-proposal',
    category: 'Policy & Proposals',
    summary: 'Create a new motor proposal',
    description:
      'Creates a new insurance proposal for a client and vehicle, returning the proposal, note and amount due for payment.',
  },
  'getPolicydetails': {
    slug: 'get-policy-details',
    category: 'Policy & Proposals',
    summary: 'Retrieve policy details',
    description:
      'Fetches key details of a policy (registration, commencement and expiry dates) using the proposal and agent code.',
  },
  'Check Double Insurance': {
    slug: 'check-double-insurance',
    category: 'Policy & Proposals',
    summary: 'Check for duplicate insurance cover',
    description:
      'Checks whether a vehicle (by chassis number or registration) already has active cover with Definite Assurance, to prevent double insurance.',
  },
  'InitiatePayment': {
    slug: 'initiate-payment',
    category: 'Payments',
    summary: 'Initiate payment for a proposal',
    description:
      'Submits a payment (e.g. M-Pesa transaction) against a proposal note. On success, the policy is approved and ready for certificate issuance.',
  },
  'Pay For Extension': {
    slug: 'pay-for-extension',
    category: 'Payments',
    summary: 'Pay for a policy extension',
    description:
      'Submits payment for a previously initiated policy extension note, approving the extension so a certificate can be issued.',
  },
  'InitiateExtension': {
    slug: 'initiate-extension',
    category: 'Extensions & Certificates',
    summary: 'Initiate a policy extension',
    description:
      'Starts an extension on an existing proposal for a new commencement date and payment interval, returning the amount due.',
  },
  'Generate Certificate': {
    slug: 'generate-certificate',
    category: 'Extensions & Certificates',
    summary: 'Generate an insurance certificate',
    description:
      'Generates the DMVIC insurance certificate for a paid proposal or extension note, returning the certificate number and a downloadable URL.',
  },
  'Cancel Policy': {
    slug: 'cancel-policy',
    category: 'Cancellations',
    summary: 'Cancel an existing policy',
    description:
      'Cancels an active policy for a given proposal and agent, using one of the reasons returned by the Cancellation Reasons endpoint.',
  },
  'Cancellation reasons': {
    slug: 'cancellation-reasons',
    category: 'Cancellations',
    summary: 'List valid cancellation reasons',
    description:
      'Returns the reference list of cancellation reasons and whether each is applicable to policies, certificates, or both.',
  },
  'CheckCreditLimit': {
    slug: 'check-credit-limit',
    category: 'Wallet & Credit',
    summary: "Check an agent's credit limit",
    description:
      'Returns the available credit limit for an agent, identified by their agent code.',
  },
  'Wallet Balance': {
    slug: 'wallet-balance',
    category: 'Wallet & Credit',
    summary: "Check an agent's wallet balance",
    description:
      'Returns the current wallet balance for an agent, identified by their agent code.',
  },
  'Topupwallet': {
    slug: 'topup-wallet',
    category: 'Wallet & Credit',
    summary: "Top up an agent's wallet",
    description:
      "Credits an agent's wallet by the given amount, typically following an M-Pesa payment identified by the phone number used.",
  },
};

export const categoryOrder = [
  'Client Management',
  'Intermediary Management',
  'Products & Pricing',
  'Policy & Proposals',
  'Payments',
  'Wallet & Credit',
  'Extensions & Certificates',
  'Cancellations',
];

export default endpointMeta;
